module.exports = __webpack_public_path__ + "img/金融英文.4b565044.png";